import {
  servicesCardsTextsExperimentGroups,
  servicesCardsTextsExperimentName,
  TServicesCardsTextsExperimentGroupsNames,
} from './servicesCardsTextsExperiment';
import {
  servicesVerticalCardsExperimentGroups,
  servicesVerticalCardsExperimentName,
  TServicesVerticalCardsExperimentGroupsNames,
} from './servicesCardsVerticalDesignExperiment';

export const allExperiments = {
  [servicesCardsTextsExperimentName]: servicesCardsTextsExperimentGroups,
  [servicesVerticalCardsExperimentName]: servicesVerticalCardsExperimentGroups,
};
export type TExperimentsGroups = TServicesCardsTextsExperimentGroupsNames | TServicesVerticalCardsExperimentGroupsNames;
export type TExperiments = typeof allExperiments;
export type TExperimentsNames = keyof typeof allExperiments;
